import Component from "./ProgramStatusIconLegend";

export default Component;
